import { useEffect, useRef, useState } from 'react';
import { BaseProps } from '../../common/BaseProps';
import styles from './Accordion.module.css';
import configuration from '../../envConfig';
import { Dialog, DialogContent, DialogContentText } from '@material-ui/core';

interface Props extends BaseProps {
  title: any;
  subtitle?: any;
  secondSubtitle?: any;
  icon?: string;
  open?: boolean;
  scroll?: boolean;
  scrollOffset?: number;
  separator?: boolean;
  alwaysOpen?: boolean;
  callback?: () => void;
  styleContent?: string;
  exibirSubtitulo?: boolean;
  observationTitle?: string;
  textoExplicativo?: string;
  textoDetalhamento?: string;
}

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const SCROLL_OFFSET_NAV_FIXED = configuration.isCordova ? -80 : -150;

const Accordion: React.FC<Props> = (props) => {
  const [open, setOpen] = useState(props.open);
  const prevOpen = usePrevious(open);
  const [exibirTextoExplicativo, setExibirTextoExplicativo] = useState(false);

  useEffect(() => {
    if (prevOpen !== open && open && props.id && props.scroll) {
      const elem = document.getElementById(props.id);
      const rootEl = document.getElementById('root');
      if (elem && rootEl) {
        const rect = elem.getBoundingClientRect();
        let scrollTo = rect.top + rootEl.scrollTop;
        if (props.scrollOffset) {
          scrollTo += props.scrollOffset;
        }
        rootEl?.scrollTo({ top: scrollTo, behavior: 'smooth' });
      }
    }
  }, [prevOpen, open, props.id, props.scroll, props.scrollOffset]);

  const toggleAccordion = () => {
    if (!open && props.callback) {
      props.callback();
    }

    if (!props.alwaysOpen) {
      setOpen(!open);
    }
  };

  const exibirIconeExplicativo = () => {
    return (
      props.textoExplicativo &&
        <div className={styles.iconeExplicativo}>
          <i
            className={`fas fa-question-circle ${styles.helpIcon}`}
            onClick={() => setExibirTextoExplicativo(true)}
          />
            <Dialog
              open={exibirTextoExplicativo}
              onClose={() => setExibirTextoExplicativo(false)}
            >
              <DialogContent>
                <DialogContentText>
                  <div className={styles.textoDialogo}>{props.textoExplicativo}</div>
                </DialogContentText>
              </DialogContent>
            </Dialog>
        </div>
    )
  }

  return (
    <div id={props.id} className={`${styles.container}  ${props.className ? props.className : ''}`}>
      <div
        className={`${styles.header} ${
          props.separator && (open || props.alwaysOpen) ? styles.separator : ''
        } ${!props.alwaysOpen ? styles.pointer : ''}`}
        onClick={() => toggleAccordion()}
      >
        {props.icon && <i className={`fa ${props.icon} ${styles.icon}`} />}
        {!props.secondSubtitle &&
          <div className="flex-column">
            <div>
              <div className={`flex-row  ${styles.title}`}>{props.title}<div>{exibirIconeExplicativo()}</div></div>

            </div>
            {(props.exibirSubtitulo || (props.subtitle && !open && !props.alwaysOpen)) && <div>{props.subtitle}</div>}
            <div className={styles.observationTitle}>{props.observationTitle}</div>
          </div>}

        {props.secondSubtitle &&
          <div className="flex-column">
            <div className={`flex-row  ${styles.title}`}>{props.title}</div>
            {!open && !props.alwaysOpen && <div>{props.subtitle}<br/>{props.secondSubtitle}</div>}
            <div className={styles.observationTitle}>{props.observationTitle}</div>
          </div>}

        {!props.textoDetalhamento && !props.alwaysOpen && (
          <i className={`fa ${open ? 'fa-chevron-up' : 'fa-chevron-down'} ${styles.chevronIcon}`} />
          )}

        {props.textoDetalhamento && <span className={styles.textoDetalhamento}>{props.textoDetalhamento ? props.textoDetalhamento : ''}</span>} 
        
      </div>
      {(open || props.alwaysOpen) && <div className={`${props.styleContent ? props.styleContent : styles.content}`}>{props.children}</div>}
    </div>
  );
};

export default Accordion;
